import type { TranslationSchema } from './en';

/**
 * Hindi translations for CascadeTech Solutions website
 * All text content translated to Hindi including H1-H5 headings
 */
const hi: TranslationSchema = {
    // --- NAVBAR ---
    nav: {
        home: "होम",
        about: "हमारे बारे में",
        services: "सेवाएं",
        team: "टीम",
        contact: "संपर्क",
        getStarted: "शुरू करें",
    },

    // --- HERO SECTION ---
    hero: {
        label: "अगली पीढ़ी का तकनीकी साझीदार",
        title1: "बुद्धिमान और स्केलेबल",
        title2: "डिजिटल समाधान प्रदान करना",
        description: "कैस्केड स्पेस उन्नत सॉफ्टवेयर, वेब प्लेटफॉर्म और आर्टिफिशियल इंटेलिजेंस समाधान बनाने में विशेषज्ञ है जो व्यवसायों को नवाचार करने, संचालन को सुव्यवस्थित करने और स्थायी विकास प्राप्त करने में सशक्त बनाता है।",
        cta1: "हमारी विशेषज्ञता देखें",
        cta2: "हमारे सलाहकारों से जुड़ें",
        trustPowered: "AI-संचालित",
        trustUptime: "99.9% विश्वसनीय",
        trustSupport: "विशेषज्ञ सहायता",
    },

    // --- HOME SECTIONS ---
    home: {
        powLabel: "नवाचार के वर्ष",
        powProjects: "परियोजनाएं पूर्ण",
        powLive: "लाइव उत्पाद",
        powClient: "ग्राहक-केंद्रित",
        statDesc1: "2023 से निर्माण",
        statDesc2: "स्टार्टअप और उद्यमों में",
        statDesc3: "स्टार्टोपिया · टेक्स्टयोरबॉस.ai · और भी",
        statDesc4: "परिणाम-संचालित डिलीवरी मॉडल",

        servicesLabel: "हमारी सेवाएं",
        servicesTitle: "अपने व्यवसाय को बदलने के लिए तैयार हैं?",
        servicesDesc: "कैस्केड स्पेस आपके व्यावसायिक उद्देश्यों के साथ संरेखित करने के लिए डिज़ाइन किए गए अत्याधुनिक तकनीकी समाधान प्रदान करता है। हमारी विशेषज्ञता डिजिटल परिवर्तन से लेकर आर्टिफिशियल इंटेलिजेंस तक फैली हुई है, जो सगाई के हर चरण में मापने योग्य परिणाम सुनिश्चित करती है।",
        servicesBtn: "सभी सेवाएं देखें",

        hwwLabel: "हमारी प्रक्रिया",
        hwwTitle: "हम उत्कृष्टता कैसे प्रदान करते हैं",
        hwwBody: "हम एक संरचित, पुनरावृत्त दृष्टिकोण का पालन करते हैं — खोज से तैनाती तक — यह सुनिश्चित करते हुए कि हर समाधान सटीक, स्केलेबल और भविष्य के लिए तैयार हो।",

        techBridgeLabel: "सेवा से समाधान तक",
        techBridgeBody: "हम केवल सॉफ्टवेयर नहीं बनाते। हम पारिस्थितिकी तंत्र का निर्माण करते हैं — आपके ब्रांड, संचालन और ग्राहकों को एक निर्बाध, बुद्धिमान प्लेटफॉर्म में जोड़ते हैं।",
        techBridgeCta: "पूरा पोर्टफोलियो देखें",

        featuresLabel: "कैस्केड लाभ",
        featuresTitle: "उद्योग के नेता हमें क्यों चुनते हैं",

        contactLabel: "सहयोग",
        contactTitle: "अपने डिजिटल परिवर्तन को तेज़ करें",

        // Projects section
        projectsTitle: "हमारी नवाचार परियोजनाएं",
        projectsDesc: "वास्तविक दुनिया की समस्याओं को हल करने और व्यावसायिक विकास को बढ़ावा देने के लिए डिज़ाइन किए गए हमारे अत्याधुनिक प्लेटफॉर्म और उपकरणों की खोज करें।",
        projectsViewAll: "सभी परियोजनाएं देखें",
        projectsLearnMore: "और जानें",
    },
    // --- ABOUT ---
    about: {
        heroLabel: "कैस्केड स्पेस के बारे में",
        heroTitle: "प्रौद्योगिकी और नवाचार के माध्यम से व्यवसायों को सशक्त बनाना",
        heroDesc: "हम स्मार्ट डिजिटल समाधान बनाते हैं जो व्यक्तियों, स्टार्टअप्स और उद्यमों के लिए उत्पादकता, दक्षता और मापनीयता को बढ़ाते हैं।",

        visionLabel: "भविष्य की दृष्टि",
        visionTitle: "एक वैश्विक तकनीकी पावरहाउस बनना",
        missionLabel: "हमारा मिशन",
        missionTitle: "प्रौद्योगिकी के माध्यम से जटिल चुनौतियों को सरल बनाना",

        visionMissionLabel: "हमारा उद्देश्य",
        visionBody: "कैस्केड स्पेस एक ऐसे भविष्य के निर्माण के लिए प्रतिबद्ध है जहां नवाचार सीमाओं से परे हो। हमारी दृष्टि दुनिया भर के उद्योगों और समुदायों में परिवर्तनकारी प्रभाव के साथ विश्व स्तरीय प्रौद्योगिकी समाधान प्रदान करना है।",
        missionBody: "कैस्केड स्पेस में, हमारा मिशन जटिलता को स्पष्टता में बदलना है। हम संगठनों को लागत प्रभावी, उच्च गुणवत्ता वाले डिजिटल समाधानों के माध्यम से नवाचार करने, विस्तार करने और फलने-फूलने में सक्षम बनाने के लिए समर्पित हैं।",
        visionBullet1: "हर पैमाने के लिए AI-प्राथमिक समाधान",
        visionBullet2: "भारत की डिजिटल खाई को पाटना",
        visionBullet3: "अगली पीढ़ी के EdTech और FinTech का नेतृत्व",

        missionLabel2: "हमारा मिशन",
        missionSubtitleH2: "महत्वाकांक्षा को निष्पादन से जोड़ना",
        missionBody1: "कैस्केड स्पेस में, हमारा मिशन डिजिटल युग की जटिलताओं को समझना और सुव्यवस्थित, बुद्धिमान प्रणालियों को प्रदान करना है जो मानवीय क्षमता और संगठनात्मक विकास को बढ़ाती हैं।",
        missionBody2: "हमारा मानना है कि सच्चा नवाचार केवल नवीनतम तकनीक को अपनाने में नहीं, बल्कि इसे वास्तविक दुनिया की समस्याओं को हल करने के लिए कुशलता से लागू करने में है। हमारे द्वारा बनाया गया हर उत्पाद स्केल और टिकाऊ होने के लिए डिज़ाइन किया गया है।",
        missionCardP1: "स्केलेबल आर्किटेक्चर पर सावधानीपूर्वक ध्यान देने के साथ निर्दोष रूप से निष्पादित।",
        missionCardP2: "अनूठे शानदार डिजिटल समाधान तैयार करने के लिए यथास्थिति को चुनौती देना।",

        coreValuesLabel: "मूल मूल्य",
        valDesc0: "आधुनिक तकनीकी स्टैक के साथ संभावनाओं की सीमाओं को लगातार आगे बढ़ाना।",
        valDesc1: "आपके व्यवसाय के विस्तार के साथ निर्बाध रूप से बढ़ने के लिए डिज़ाइन किए गए आर्किटेक्चर का निर्माण।",
        valDesc2: "एक पारिस्थितिकी तंत्र को बढ़ावा देना जहाँ टीमों और ग्राहकों के पास सफल होने के लिए उपकरण हों।",

        teamLabel: "नेतृत्व",
        teamTitle: "तकनीक के पीछे के दिमाग",
        teamDesc: "एक छोटी, अथक टीम जो अपने वजन से कहीं अधिक मुक्का मारती है।",

        projectsLabel: "हमारा काम",
        projectsTitle: "परियोजनाएं जो हमें परिभाषित करती हैं",
        projectsBodyDesc: "सटीकता के साथ निर्मित समाधानों का प्रदर्शन — हर परियोजना हमारी इंजीनियरिंग संस्कृति का प्रमाण।",
        projectsComingSoon: "और नवाचार जल्द आ रहे हैं ✦",
        ctaBannerTitle: "आइए कुछ असाधारण बनाएं",
        ctaBannerDesc: "अपनी दृष्टि को विश्व स्तरीय डिजिटल उत्पाद में बदलने के लिए कैस्केडटेक के साथ साझेदारी करें।",
    },

    // --- SERVICES ---
    services: {
        heroLabel: "हम क्या करते हैं",
        heroDesc: "अवधारणा से तैनाती तक, हम ऐसे समाधान तैयार करते हैं जो सटीक, प्रदर्शनकारी और भविष्य के लिए तैयार हों।",

        engagementLabel: "हमारा एंगेजमेंट मॉडल",
        engagementTitle: "विचार से प्रभाव तक का सिद्ध मार्ग",
        engagementBody: "हम एक संरचित एंगेजमेंट मॉडल का पालन करते हैं जो अस्पष्टता को दूर करता है और सुनिश्चित करता है कि हर परियोजना समय पर, दायरे के भीतर और अपेक्षाओं से परे पहुंचाई जाए।",

        catDTTitle: "डिजिटल परिवर्तन",
        catDTDesc: "हम संगठनों को व्यापक डिजिटल ओवरहॉल के माध्यम से मार्गदर्शन करते हैं, विरासत प्रणालियों को आधुनिक, स्केलेबल आर्किटेक्चर में स्थानांतरित करते हैं जो दक्षता में सुधार करते हैं और परिचालन ओवरहेड को कम करते हैं।",
        catDTF1: "एंटरप्राइज़ आर्किटेक्चर माइग्रेशन",
        catDTF2: "क्लाउड इन्फ्रास्ट्रक्चर सेटअप और अनुकूलन",
        catDTF3: "विरासत सिस्टम आधुनिकीकरण",
        catDTF4: "वर्कफ़्लो स्वचालन",

        catAITitle: "AI और स्मार्ट समाधान",
        catAIDesc: "जटिल कार्यों को स्वचालित करने, भविष्यसूचक अंतर्दृष्टि उत्पन्न करने और बड़े पैमाने पर व्यक्तिगत अनुभव बनाने के लिए आर्टिफिशियल इंटेलिजेंस की शक्ति का लाभ उठाएं।",
        catAIF1: "कस्टम LLM एकीकरण और फाइन-ट्यूनिंग",
        catAIF2: "संवादी AI और चैटबॉट्स",
        catAIF3: "भविष्यसूचक डेटा एनालिटिक्स",
        catAIF4: "बुद्धिमान प्रक्रिया स्वचालन",

        catDBTitle: "डिज़ाइन और ब्रांडिंग",
        catDBDesc: "आपकी डिजिटल उपस्थिति आपकी महत्वाकांक्षा को दर्शाना चाहिए। हम प्रीमियम, उपयोगकर्ता-केंद्रित इंटरफेस और ब्रांड पहचान तैयार करते हैं जो आपके लक्षित दर्शकों के साथ गूंजती हैं।",
        catDBF1: "यूजर इंटरफेस (UI) डिज़ाइन",
        catDBF2: "यूजर एक्सपीरियंस (UX) रिसर्च",
        catDBF3: "ब्रांड पहचान और रणनीति",
        catDBF4: "इंटरैक्टिव प्रोटोटाइप",

        ctaBannerTitle: "अपना प्लेटफॉर्म बनाने के लिए तैयार हैं?",
        ctaBannerDesc: "चाहे आपको पूर्ण डिजिटल परिवर्तन की आवश्यकता हो या एक विशिष्ट AI मॉड्यूल की, हमारी टीम निष्पादित करने के लिए तैयार है।",

        cta: "मुफ्त परामर्श प्राप्त करें",
        discussService: "इस सेवा पर चर्चा करें",
    },
    // --- CONTACT ---
    contact: {
        heroLabel: "संपर्क में रहें",
        heroTitle: "आइए मिलकर कुछ महान बनाएं",
        contactBody: "कोई परियोजना मन में है या हमारी सेवाओं के बारे में प्रश्न हैं? हम आपसे सुनना पसंद करेंगे।",

        name: "आपका नाम",
        email: "ईमेल पता",
        message: "आपका संदेश",
        send: "संदेश भेजें",

        formResponseTime: "हम 24-48 घंटों के भीतर आपसे संपर्क करेंगे।",
        businessHours: "सोमवार-शुक्रवार, सुबह 9 बजे-शाम 5 बजे IST",
        hqTitle: "कैस्केडटेक सॉल्यूशंस मुख्यालय",
        hqLocation: "विद्या-नगर, हुबली",
    },

    // --- PROJECTS PAGE ---
    projectsPage: {
        heroLabel: "पोर्टफोलियो और केस स्टडीज",
        heroDesc: "हमारे पोर्टफोलियो और उपकरणों का अन्वेषण करें जो वास्तविक दुनिया की समस्याओं को हल करने और व्यावसायिक विकास को गति देने के लिए डिज़ाइन किए गए हैं।",

        startopiaTitle: "स्टार्टोपिया",
        startopiaDesc: "संस्थापकों को संसाधनों, निवेशक कनेक्शन और अत्यधिक स्केलेबल तकनीकी प्लेटफॉर्म के साथ सशक्त बनाने के लिए डिज़ाइन किया गया एक व्यापक पारिस्थितिकी तंत्र।",
        startopiaFeat1: "एंड-टू-एंड एन्क्रिप्शन",
        startopiaFeat2: "स्वचालित मैचमेकिंग",
        startopiaFeat3: "रियल-टाइम एनालिटिक्स",
        startopiaFeat4: "स्केलेबल माइक्रोसर्विसेज",
        startopiaPreview: "स्टार्टोपिया पूर्वावलोकन",

        textYourBossTitle: "टेक्स्टयोरबॉस.ai",
        textYourBossDesc: "एक AI-संचालित संचार उपकरण जो पेशेवर संदेश, वर्कफ़्लो स्वचालन और एंटरप्राइज़ टीमों के लिए संदर्भ-जागरूक प्रतिक्रियाओं को सरल बनाता है।",
        textYourBossFeat1: "संदर्भ-जागरूक AI जेनरेशन",
        textYourBossFeat2: "टोन एडजस्टमेंट इंजन",
        textYourBossFeat3: "मल्टी-प्लेटफॉर्म एकीकरण",
        textYourBossFeat4: "एंटरप्राइज़ भूमिका-आधारित पहुंच",
        textYourBossPreview: "टेक्स्टयोरबॉस.ai इंटरफेस",

        comingSoonLabel: "नवाचार पाइपलाइन",
        futureProj1Title: "नवीकरणीय ऊर्जा प्लेटफॉर्म",
        futureProj1Desc: "रियल-टाइम में सौर और पवन फार्म प्रदर्शन की निगरानी और अनुकूलन के लिए एक IoT-सक्षम डैशबोर्ड।",
        futureProj1Status: "विकास में",

        futureProj2Title: "एल्गोरिदमिक ट्रेडिंग बॉट",
        futureProj2Desc: "जटिल वित्तीय रणनीतियों को निष्पादित करने के लिए मशीन लर्निंग का लाभ उठाने वाला एक उच्च-आवृत्ति ट्रेडिंग एल्गोरिदम।",
        futureProj2Status: "बीटा परीक्षण",

        futureProj3Title: "स्वायत्त रोबोटिक्स API",
        futureProj3Desc: "विविध औद्योगिक रोबोटिक्स सिस्टम के बीच निर्बाध एकीकरण को सक्षम करने वाला एक मानकीकृत संचार API।",
        futureProj3Status: "अनुसंधान चरण",

        ctaBannerTitle: "कोई परियोजना मन में है?",
        ctaBannerDesc: "आइए कुछ असाधारण बनाने के लिए सहयोग करें जो आपके उद्योग की सीमाओं को आगे बढ़ाए।",
    },

    // --- TEAM PAGE ---
    teamPage: {
        heroLabel: "हमारा नेतृत्व",
        heroDesc: "हमारे दूरदर्शी नेताओं से मिलें जो व्यापार के विकास और नवाचार के लिए तकनीक के उपयोग के तरीके को बदल रहे हैं।",

        akshayBio: "अक्षय कुमार अंकलगी कैस्केडटेक सॉल्यूशंस के दूरदर्शी सीईओ हैं, जो तकनीकी नेतृत्व और व्यावसायिक परिवर्तन में व्यापक अनुभव लाते हैं। उनकी रणनीतिक अंतर्दृष्टि और भविष्य की सोच वाले दृष्टिकोण ने कैस्केडटेक को डिजिटल नवाचार में एक नेता के रूप में स्थापित किया है। अक्षय बाजार के अवसरों की पहचान करने और ऐसे समाधान विकसित करने में विशेषज्ञ हैं जो उद्योगों में ग्राहकों के लिए स्थायी मूल्य बनाते हैं।",
        manojBio: "मनोज रेलेकर कैस्केडटेक सॉल्यूशंस की परिचालन रीढ़ के रूप में काम करते हैं, असाधारण संगठनात्मक नेतृत्व और प्रक्रिया अनुकूलन विशेषज्ञता लाते हैं। तकनीक और व्यावसायिक संचालन में फैली पृष्ठभूमि के साथ, मनोज सुनिश्चित करते हैं कि हमारी सेवा डिलीवरी लगातार ग्राहक अपेक्षाओं से अधिक हो। संचालन को स्केल करने के लिए उनका पद्धतिगत दृष्टिकोण कैस्केडटेक के स्थायी विकास प्रक्षेपवक्र में महत्वपूर्ण रहा है।",
        vaibhavaBio: "वैभव बीजी सीटीओ के रूप में कैस्केडटेक के तकनीकी नवाचार का नेतृत्व करते हैं, गहरी तकनीकी विशेषज्ञता को रचनात्मक समस्या-समाधान क्षमताओं के साथ जोड़ते हैं। AI, ब्लॉकचेन और क्लाउड आर्किटेक्चर जैसी उभरती तकनीकों के लिए उनका जुनून हमारे उत्पाद विकास रोडमैप को संचालित करता है। स्केलेबल, सुरक्षित डिजिटल प्लेटफॉर्म बनाने में वैभव का नेतृत्व हमारे ग्राहकों की सबसे जटिल चुनौतियों के लिए परिवर्तनकारी समाधान प्रदान करने में महत्वपूर्ण रहा है।",

        coreValuesLabel: "हमारे सिद्धांत",
        coreValuesTitle: "वे आदर्श जो हमें स्थिर रखते हैं",
        valInnovationDesc: "नई तकनीकों और दृष्टिकोणों की लगातार खोज।",
        valExcellenceDesc: "सटीकता और विस्तार पर ध्यान देने के साथ अपेक्षाओं से अधिक।",
        valIntegrityDesc: "ईमानदार, पारदर्शी प्रथाओं के माध्यम से विश्वास का निर्माण।",
        valCollaborationDesc: "व्यापक समाधानों के लिए विषयों में मिलकर काम करना।",

        ctaBannerTitle: "हमारे बढ़ते पारिस्थितिकी तंत्र में शामिल हों",
        ctaBannerDesc: "हम हमेशा दूरदर्शी ग्राहकों और प्रतिभाशाली दिमागों के साथ सहयोग करने की तलाश में रहते हैं।",
    },
    // --- NOT FOUND ---
    notFound: {
        title: "सिस्टम नोड नहीं मिला",
        desc: "आपके द्वारा अनुरोधित प्रक्षेपवक्र हमारे डिजिटल बुनियादी ढांचे में मौजूद नहीं है। कृपया मुख्य मॉड्यूल पर वापस जाएं।",
        backToHome: "मुख्य अनुक्रम प्रारंभ करें",
    },

    // --- FOOTER ---
    footer: {
        desc: "अत्याधुनिक तकनीक के माध्यम से व्यवसायों को सशक्त बनाना, वेब डिज़ाइन, सॉफ्टवेयर विकास और बुद्धिमान डिजिटल समाधानों में विशेषज्ञता।",
        company: "कंपनी",
        services: "सेवाएं",
        contact: "संपर्क",
        rights: "कैस्केडटेक सॉल्यूशंस। सभी अधिकार सुरक्षित।",
        tagline: "सटीकता के साथ निर्मित · स्केल करने के लिए इंजीनियर्ड",
    },

    // --- GENERIC CTA ---
    cta: {
        startProject: "अपनी परियोजना शुरू करें",
        learnMore: "और जानें",
        getInTouch: "संपर्क में रहें",
    },

    // --- HEADINGS SUPPLEMENT ---
    headings: {
        techTitle: "हमारी सेवाओं को कार्य में देखें",
        emailUs: "हमें ईमेल करें",
        visitUs: "हमसे मिलें",
        infoEmail: "ईमेल",
        infoPhone: "फोन",
        infoAddress: "पता",
        infoHours: "व्यावसायिक घंटे",
        formTitle: "हमें संदेश भेजें",
        missionSubtitle: "महत्वाकांक्षा को निष्पादन से जोड़ना",
        valPrecision: "सटीकता",
        valInnovation: "नवाचार",
        valExcellence: "उत्कृष्टता",
        valIntegrity: "अखंडता",
        valCollaboration: "सहयोग",
        visionSubtitle: "कल का आर्किटेक्चर",
        projectsHeroTitle: "परिणाम संचालित करने वाले अभिनव समाधान",
        teamHeroTitle: "कैस्केडटेक सॉल्यूशंस के पीछे की टीम",
        ctaBannerTitle: "अपनी डिजिटल उपस्थिति को बदलने के लिए तैयार हैं?",
        comingSoon: "लॉन्च की तैयारी",
        servicesHeroH1: "आधुनिक एंटरप्राइज़ के लिए बुद्धिमान समाधान",
        discussService: "इस सेवा पर चर्चा करें",
        viewCaseStudy: "केस स्टडी देखें",
        valuesSectionTitle: "क्या हमें आगे बढ़ाता है",
        builtOnPrinciple: "सिद्धांत पर निर्मित",
        mindsBehinTech: "तकनीक के पीछे के दिमाग",
        contactHeroTitle: "आइए मिलकर कुछ महान बनाएं",
        intelligence: "बुद्धिमत्ता",
        missionPillarSpeed: "गति",
        missionPillarReliability: "विश्वसनीयता",
        missionPillarReach: "पहुंच",
        missionPillarIntelligence: "बुद्धिमत्ता",
        futureVisionBody: "हम तकनीक की तत्काल बाधाओं से परे देखते हैं। AI पारिस्थितिकी तंत्र, स्मार्ट स्वचालन और नवीकरणीय तकनीकी समाधानों में निवेश करके, कैस्केड स्पेस स्थायी बुनियादी ढांचा बनाने के लिए समर्पित है जो डिजिटल विकास के अगले दशक को आकार देता है।",
        futureVisionCta: "हमारे आगामी नवाचार देखें",
    },

    // --- BODY TEXT ---
    body: {
        labelName: "नाम",
        labelEmail: "ईमेल",
        labelCompany: "कंपनी",
        labelMessage: "संदेश",
        optional: "(वैकल्पिक)",
        placeholderName: "जॉन डो",
        placeholderEmail: "john@company.com",
        placeholderCompany: "आपका संगठन",
        placeholderMessage: "हमें अपनी परियोजना के बारे में बताएं या हमसे कुछ भी पूछें...",
        formSubDesc: "नीचे दिया गया फॉर्म भरें और हम जल्द से जल्द आपसे संपर्क करेंगे।",
        contactDesc: "कोई परियोजना मन में है या हमारी सेवाओं के बारे में प्रश्न हैं? हम आपसे सुनना पसंद करेंगे।",
        contactTeamReady: "चाहे आपके पास कोई विशिष्ट परियोजना हो या रणनीतिक मार्गदर्शन की आवश्यकता हो, हमारी टीम तैयार है।",
        callUs: "हमें कॉल करें",
        visionBody: "भारत और उससे आगे के व्यवसायों के लिए सबसे विश्वसनीय तकनीकी साझीदार बनना — बुद्धिमान, सुलभ डिजिटल पारिस्थितिकी तंत्र का निर्माण करना।",
        missionBody: "डिजिटल युग की जटिलताओं को समझना और सुव्यवस्थित, बुद्धिमान प्रणालियों को प्रदान करना जो मानवीय क्षमता को बढ़ाती हैं।",
        visionBullet1: "हर पैमाने के लिए AI-प्राथमिक समाधान",
        visionBullet2: "भारत की डिजिटल खाई को पाटना",
        visionBullet3: "अगली पीढ़ी के EdTech और FinTech का नेतृत्व",
        teamSmallDesc: "एक छोटी, अथक टीम जो अपने वजन से कहीं अधिक मुक्का मारती है।",
        meetFullTeam: "पूरी टीम से मिलें",
        projectsComingSoon: "और नवाचार जल्द आ रहे हैं ✦",
        keyFeatures: "मुख्य विशेषताएं",
        heroTeamDesc: "तकनीक के माध्यम से व्यवसायों को बदलने के लिए प्रतिबद्ध भावुक नेता।",
        exploreExpertise: "हमारी विशेषज्ञता देखें",
        engageConsultants: "हमारे सलाहकारों से जुड़ें",
        sendMessage: "संदेश भेजें",
        ourPurpose: "हमारा उद्देश्य",
        coreValues: "मूल मूल्य",
        viewPortfolio: "पूरा पोर्टफोलियो देखें",
        showcaseDesc: "सटीकता के साथ निर्मित समाधानों का प्रदर्शन — हर परियोजना हमारी इंजीनियरिंग संस्कृति का प्रमाण।",
        footerSvcWebDev: "वेबसाइट विकास",
        footerSvcWebDesign: "वेब डिज़ाइन और UI/UX",
        footerSvcSoftDev: "सॉफ्टवेयर विकास",
        footerSvcAI: "AI और चैटबॉट विकास",
        footerSvcEdTech: "शैक्षिक तकनीक",
        footerSvcLoyalty: "लॉयल्टी प्रोग्राम समाधान",

        // TechBridge benefits
        techBridgeBen1: "एंड-टू-एंड डिजिटल परिवर्तन",
        techBridgeBen2: "AI-संचालित स्वचालन और अंतर्दृष्टि",
        techBridgeBen3: "स्केलेबल क्लाउड आर्किटेक्चर",
        techBridgeBen4: "प्रीमियम UI/UX डिज़ाइन सिस्टम",

        // HowWeWork step bodies
        // HowWeWork step bodies (steps 1–4)
        hwwStepBody1: "हम आपके व्यावसायिक परिदृश्य का मानचित्रण करके शुरुआत करते हैं — आपके लक्ष्य, बाधाएं और सतह के नीचे की वास्तविक समस्याएं। कोई अनुमान नहीं, कोई शॉर्टकट नहीं।",
        hwwStepBody2: "हमारी तकनीकी टीम एक स्केलेबल, भविष्य-प्रूफ समाधान ब्लूप्रिंट डिज़ाइन करती है। हर प्रौद्योगिकी निर्णय जानबूझकर, दस्तावेज़ीकृत और आपके व्यावसायिक परिणामों के अनुरूप होता है।",
        hwwStepBody3: "हम निरंतर फीडबैक लूप के साथ स्प्रिंट में बनाते हैं। आप प्रगति देखते हैं, सिर्फ वादे नहीं — हर मील पत्थर पर काम करने वाली डिलिवरेबल्स के साथ।",
        hwwStepBody4: "तैनाती शुरुआत है, अंत नहीं। हम पोस्ट-लॉन्च सपोर्ट, प्रदर्शन निगरानी और पुनरावृत्त सुधार प्रदान करते हैं जैसे-जैसे आपका व्यवसाय बढ़ता है।",

        // HowWeWork main body
        howWeWorkBody: "हम एक संरचित, पुनरावृत्त दृष्टिकोण का पालन करते हैं — खोज से तैनाती तक — यह सुनिश्चित करते हुए कि हर समाधान सटीक, स्केलेबल और भविष्य के लिए तैयार हो।",

        // Project descriptions for TechBridge section
        startopiaShortDesc: "संस्थापकों को संसाधनों और स्केलेबल प्लेटफॉर्म के साथ सशक्त बनाने के लिए डिज़ाइन किया गया एक व्यापक पारिस्थितिकी तंत्र।",
        textYourBossShortDesc: "एक AI-संचालित संचार उपकरण जो पेशेवर संदेश और वर्कफ़्लो स्वचालन को सरल बनाता है।",

        // Full project descriptions
        startopiaFullDesc: "स्टार्टअप को निवेशकों, सलाहकारों और आवश्यक सेवाओं से जोड़ने वाला एक व्यापक प्लेटफॉर्म जो विकास को तेज़ करता है और फंडिंग सुरक्षित करता है।",
        textYourBossFullDesc: "उद्यमियों और अधिकारियों को तत्काल व्यावसायिक मार्गदर्शन, निर्णय समर्थन और रणनीतिक अंतर्दृष्टि प्रदान करने वाला एक AI-संचालित प्लेटफॉर्म।",

        // Project tags
        tagStartupGrowth: "स्टार्टअप विकास",
        tagInvestorMatching: "निवेशक मैचिंग",
        tagMentorship: "सलाह",
        tagFunding: "फंडिंग",
        tagAI: "आर्टिफिशियल इंटेलिजेंस",
        tagBusinessGuidance: "व्यावसायिक मार्गदर्शन",
        tagDecisionSupport: "निर्णय समर्थन",
        tagStrategy: "रणनीति",
    },
    // --- ARRAYS ---
    // All 4 HowWeWork step titles
    hwwSteps: [
        "गहरी खोज",
        "रणनीतिक वास्तुकला",
        "सटीक इंजीनियरिंग",
        "लॉन्च और स्केल",
    ],

    homeFeatures: [
        "डिजिटल परिवर्तन",
        "स्टार्टअप पारिस्थितिकी तंत्र",
        "AI और स्मार्ट समाधान",
        "डिज़ाइन और ब्रांडिंग",
    ],

    homeFeatureDescs: [
        "एंटरप्राइज़-ग्रेड वेबसाइटों, मोबाइल एप्लिकेशन और बुद्धिमान स्वचालन फ्रेमवर्क के माध्यम से अपने संगठन की डिजिटल नींव को मजबूत करें।",
        "संस्थापकों को निवेशकों, संसाधनों और स्केलेबल प्लेटफॉर्म तक पहुंच प्रदान करें जो त्वरित विकास और स्थायी व्यावसायिक परिणामों को बढ़ावा देते हैं।",
        "बुद्धिमान प्रणालियों को तैनात करें जो महत्वपूर्ण वर्कफ़्लो को स्वचालित करती हैं, कार्यशील अंतर्दृष्टि उत्पन्न करती हैं और निवेश पर मापने योग्य रिटर्न प्रदान करती हैं।",
        "संगठनात्मक उद्देश्यों के साथ संरेखित परिष्कृत उपयोगकर्ता अनुभव, विशिष्ट ब्रांड पहचान और रणनीतिक संचार संपत्ति तैयार करें।",
    ],

    servicesList: [
        "वेबसाइट विकास",
        "वेब डिज़ाइन और UI/UX",
        "सॉफ्टवेयर विकास",
        "AI और चैटबॉट",
        "लॉयल्टी प्रोग्राम",
        "शैक्षिक तकनीक",
    ],

    servicesListDescs: [
        "आपकी अनूठी व्यावसायिक आवश्यकताओं और लक्ष्यों के अनुकूल कस्टम वेबसाइट विकास।",
        "सहज उपयोगकर्ता अनुभवों के साथ दृश्यमान रूप से आश्चर्यजनक डिज़ाइन जो आपके दर्शकों को संलग्न करते हैं।",
        "कस्टम सॉफ्टवेयर समाधान जो संचालन को सुव्यवस्थित करते हैं और व्यावसायिक विकास को बढ़ावा देते हैं।",
        "ग्राहक अनुभव और जुड़ाव को बढ़ाने के लिए बुद्धिमान संवादी इंटरफेस।",
        "आपके व्यवसाय के लिए ग्राहक वफादारी बनाने और बनाए रखने के लिए व्यापक समाधान।",
        "सीखने के अनुभवों और शैक्षिक परिणामों को बढ़ाने के लिए नवाचार डिजिटल समाधान।",
    ],

    timelineSteps: [
        "खोज कॉल",
        "रणनीति और स्कोपिंग",
        "डिज़ाइन स्प्रिंट",
        "निर्माण और पुनरावृत्ति",
        "लॉन्च और सहायता",
    ],

    timelineStepBodies: [
        "आपके लक्ष्यों, बाधाओं और सफलता मेट्रिक्स को समझने के लिए एक केंद्रित बातचीत।",
        "हम एक विस्तृत तकनीकी दायरा, समयसीमा और निवेश विवरण तैयार करते हैं। कोई आश्चर्य नहीं।",
        "कोड की एक भी लाइन लिखे जाने से पहले उच्च-निष्ठा वायरफ्रेम और डिज़ाइन प्रोटोटाइप की समीक्षा और अनुमोदन।",
        "साप्ताहिक डेमो के साथ एजाइल स्प्रिंट। आपको हर समय प्रगति में पूर्ण दृश्यता है।",
        "तैनाती, निगरानी, प्रदर्शन अनुकूलन, और विकास के लिए निरंतर साझेदारी।",
    ],

    valuesSectionValues: [
        "नवाचार",
        "स्केलेबिलिटी",
        "सशक्तिकरण",
    ],
};

export default hi;